/**
 * Performs window.open for a given URL;
 * @param {string} url Address to display in a pop-up window
 * @param {*} width in pixels; default: 575px
 * @param {*} height in pixels; default: 400px
 */
export const openPopup = (url, width = 575, height = 400) => {
	const top = (document.documentElement.clientHeight - height) / 2;
	const left = document.documentElement.clientWidth / 2 - width / 2;
	const options = {
		status: 1,
		resizable: 'yes',
		width,
		height,
		top,
		left
	};
	const popup = window.open(
		url,
		'',
		JSON.stringify(options)
			.replace(/"|{|}/g, '')
			.replace(/:/g, '=')
	);

	if (popup) {
		popup.focus();
	}

	return popup;
};

export const openWindow = (url, name = '_blank', options = {}) => {
	const newTab = window.open(
		url,
		name,
		JSON.stringify(options)
			.replace(/"|{|}/g, '')
			.replace(/:/g, '=')
	);
	return newTab;
};
